// THIS FILE NEEDS TO BE KEPT IN SYNC WITH THE VERIFICATION SERVER
import { initializeWithZumigoSupplier } from './zumigo';
import { SupplierCode } from './supplierCodes';
import { SupplierMapping } from './types';

export const supplierMapping: SupplierMapping = {
    [SupplierCode.ZUMIGO]: {
        // fetchSupplierServerFunc is enforced to type SupplierInitializationFunction
        fetchSupplierServerFunc: initializeWithZumigoSupplier
    },
}